//
// Copyright (c) 2011-2024 by Curalate, Inc.
//

import React from 'react';
import styled from 'styled-components';

import { RouteAnchor } from '@components/RouteAnchor';
import VibeGradLogo from '@images/bv-vibe-grad.svg';
import makeAngularReactController from '@react-bridge/angular-react-widget';

export const NavLogo = () => {
  return (
    <VibeNavLink state='index' stateParams={{ viaTopNav: true }}>
      <VibeLogo alt='Vibe' src={VibeGradLogo} />
    </VibeNavLink>
  );
};

const VibeNavLink = styled(RouteAnchor)`
  text-decoration: none;

  @media only screen and (max-width: 767px) {
    display: none;
  }
`;

const VibeLogo = styled.img`
  height: 28px;
  width: 137px;
`;

angular.module('curalate').component('navLogo', {
  controller: makeAngularReactController(<NavLogo />),
});
